/* Shopify's scheduled discount owns checkout. Keep an open product page aligned at expiry. */
(() => {
  const format = (value) => {
    const currency=window.Shopify?.currency?.active || 'TRY';
    return currency==='TRY'?new Intl.NumberFormat('tr-TR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(value/100)+' TL':new Intl.NumberFormat(document.documentElement.lang || 'tr-TR',{style:'currency',currency}).format(value/100);
  };
  const refresh = () => {
    const now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-atlas-campaign-price]').forEach((element) => {
      const {start, end, offer, normal} = element.dataset;
      const active = now >= Number(start) && now < Number(end) && Number(offer) < Number(normal);
      const state = String(active);
      if (element.dataset.campaignState === state) return;
      element.dataset.campaignState = state;
      element.classList.toggle('price--on-sale', active);
      const saleBlock=element.querySelector('.price__sale');
      const previous=saleBlock?.querySelector('s.price-item');
      if(previous)previous.textContent=format(Number(normal));
      let badge=saleBlock?.querySelector('.atlas-discount');
      if(active&&saleBlock){
        if(!badge){badge=document.createElement('span');badge.className='atlas-discount';saleBlock.prepend(badge);}
        badge.textContent=`%${Math.round((Number(normal)-Number(offer))*100/Number(normal))} indirim`;
      }

      const regular = element.querySelector('.price__regular .price-item');
      if (regular) regular.textContent = format(Number(normal));
      const sale = element.querySelector('.price__sale .price-item--sale');
      if (sale) sale.textContent = format(active ? Number(offer) : Number(normal));
    });
  };
  refresh();
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', refresh);
  setInterval(refresh, 1000);
})();
